import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PoeDocumentModel } from '../../../../models/poe-document.model';
import { ProgramSharedService } from '../../../common/program-shared.service';
import { CommonSharedModule } from '../../../common/shared.module';
import { EventReviewTableComponent } from '../event-review-table/event-review-table.component';

@Component({
  selector: 'app-events-poe-documents',
  templateUrl: './events-poe-documents.component.html',
  styleUrls: ['./events-poe-documents.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, EventReviewTableComponent]
})
export class EventsPoeDocumentsComponent implements OnInit {
  poeDocumentForm!: FormGroup;
  isdocumentSelected = false;
  documentSelected!: PoeDocumentModel;
  loading = false;
  isCustomerValidationSelected = false;
  isCustomerSurveySelected = false;
  isInvoiceDocSelected = false;
  isSkuPurchaseSelected = false;
  isDAPoeSelected = false;

  poeDocumentList: PoeDocumentModel[] = [
    {
      id: 14,
      documentName: 'Customer Validation Review',
      isMandatory: true
    },
    {
      id: 2,
      documentName: 'Customer Survey Review',
      isMandatory: true
    },
    {
      id: 4,
      documentName: 'Invoice Doc Review',
      isMandatory: true
    },
    {
      id: 5,
      documentName: 'SKU Purchase/Trial Activation Review',
      isMandatory: true
    },
    {
      id: 7,
      documentName: 'Deal Association Review',
      isMandatory: true
    },
    {
      id: 13,
      documentName: 'Statement of Work',
      isMandatory: true
    }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private programSharedService: ProgramSharedService
  ) {}

  ngOnInit() {
    this.onFromGroup();
    this.setPoeDocumentList();
  }

  onFromGroup() {
    this.poeDocumentForm = this.formBuilder.group({
      poeDocument: []
    });
  }

  onpoeDocumentSelect() {
    this.documentSelected = this.poeDocumentForm.controls['poeDocument'].value;
    this.isdocumentSelected =
      !!this.poeDocumentForm.controls['poeDocument'].value;
    this.programSharedService.setReviewPoeDocumentId(this.documentSelected.id);
  }

  setPoeDocumentList() {
    this.loading = true;
    const selectedDocumentId =
      this.programSharedService.getReviewPoeDocumentId();
    if (selectedDocumentId != null) {
      this.poeDocumentForm.controls['poeDocument'].setValue(
        this.poeDocumentList.find(x => x.id == selectedDocumentId)
      );
      this.documentSelected =
        this.poeDocumentForm.controls['poeDocument'].value;
      this.isdocumentSelected =
        !!this.poeDocumentForm.controls['poeDocument'].value;
    }
    this.loading = false;
  }
}
